import {
  keepPreviousData,
  queryOptions,
  skipToken,
} from '@tanstack/react-query';

import type {
  BookingServiceAvailabilityQueryParams,
  BookingServiceAvailabilityResponse,
} from '@/types/api/queries';

import { HttpClient } from '@/network/HttpClient';

export const bookingServiceAvailabilityKeys = {
  all: () => ['bookingServiceAvailability'] as const,
  specialists: (props: BookingServiceAvailabilityQueryParams) =>
    [
      ...bookingServiceAvailabilityKeys.all(),
      'specialists',
      props.url,
      props.locationId,
      props.serviceId,
      props.date,
    ] as const,
};

export const bookingServiceAvailabilityQueries = {
  specialists: (props: BookingServiceAvailabilityQueryParams) => {
    const { url, locationId, serviceId, date } = props;

    return queryOptions({
      queryKey: bookingServiceAvailabilityKeys.specialists(props),
      queryFn:
        url && locationId && serviceId && date
          ? () =>
              HttpClient.request<BookingServiceAvailabilityResponse>({
                method: 'GET',
                url,
                params: {
                  location_id: locationId,
                  service_id: serviceId,
                  date,
                },
              })
          : skipToken,
      placeholderData: keepPreviousData,
      refetchOnWindowFocus: false,
    });
  },
};
